export enum FormState {
    SignUp = 1,
    ConfirmSignUp,
    SignIn,
    ForgotPassword,
    ConfirmForgotPassword,
    Signedin,
    LinkGoogleAccount,
    VerifyExistingAccount,
    LinkSuccess
}

export interface SignInProps {
    forModal?: boolean,
    initialState?: FormState
}
